<div class="card">
  <div class="card-header">
    <i class="fa fa-street-view"></i> Identificacion de clientes
  </div>
  <div class="card-body card-body-z-index">
    <tabset>
      <tab>
        <ng-template tabHeading><i class="fa fa-id-card"></i> Datos Generales</ng-template>
        <accordion [isAnimated]="true">
          <!-- General Information Customer Section -->
          <accordion-group [isOpen]="true">
            <span accordion-heading>
              <i class="fa fa-id-card"></i> Datos generales del cliente
            </span>
            <div class="row">
              <app-customer-information class="col-md-12" (isCurrentCustomerChanging)="handleIsCustomerChanging($event)"
                (currentCustomerChange)="handleSelectedCustomerChange($event)">
              </app-customer-information>
            </div>
            <div class="row" *ngIf="this.currentCustomer.code != ''">
              <div class="col-sm-12">
                <app-customer-information-detail [currentCustomer]="this.currentCustomer"
                  [hideCreditInformation]="false"
                  [currentCustomerCreditConditions]="this.currentCustomerCreditConditions"></app-customer-information-detail>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <app-fast-actions-buttons [currentCustomerCreditConditions]="
                    this.currentCustomerCreditConditions
                  " [currentCustomer]="this.currentCustomer" *ngIf="this.currentCustomer.code !== ''"
                  [selectedSeller]="this.selectedSeller">
                </app-fast-actions-buttons>
              </div>
            </div>
          </accordion-group>
          <!-- PreApproval Customer Section -->
          <div *appHasAccess="'preApproval'" [hidden]="!validateCustomerStatus()">
            <accordion-group *ngIf="
                !this.currentCustomerCreditConditions.creditLineActive &&
                this.currentCustomer.code !== ''
              " [isOpen]="true">
              <span accordion-heading>
                <i class="fa fa-check"></i> Pre Aprobación
              </span>
              <app-customer-credit-request-stepper [currentCustomer]="this.currentCustomer" [homeTypes]="this.homeTypes"
                [preApprovalForm]="this.preApprovalForm" [productSelectionForm]="this.productSelectionForm"
                [currentCustomerCreditConditions]="
                  this.currentCustomerCreditConditions
                " [selectedSeller]="this.selectedSeller" (quotationPlanClick)="handleQuoationPlanClick($event)"
                #creditRequestStepper>
              </app-customer-credit-request-stepper>
            </accordion-group>
          </div>
          <!-- Credit Status Customer Section -->
          <accordion-group *ngIf="
              this.currentCustomerCreditConditions.creditLineActive &&
              this.currentCustomer.code !== '' &&
              this.currentCustomerCreditStatus
            " [isOpen]="true">
            <span accordion-heading>
              <i class="fa fa-credit-card"></i> Información de crédito
            </span>
            <app-customer-credit-status [customerCreditStatus]="this.currentCustomerCreditStatus"
              [customerCreditPolicy]="this.currentCustomerCreditPolicy"></app-customer-credit-status>
          </accordion-group>
          <!-- No Customer Section -->
          <accordion-group *ngIf="this.currentCustomer.code === ''" heading="Por favor seleccione un cliente"
            [isOpen]="false">
          </accordion-group>
        </accordion>
      </tab>
      <tab>
        <ng-template tabHeading><i class="fa fa-regular fa-file"></i> Creditos Actuales &nbsp;<span
            class="badge badge-pill badge-danger">{{loansAmount}}</span></ng-template>
        <app-customer-loans-active [customer]="this.currentCustomer"
          (getAmountOfLoans)="getAmountofLoans($event)"></app-customer-loans-active>
      </tab>
      <tab>
        <ng-template tabHeading><i class="fa fa-book-open-reader"></i> Trámites en Proceso &nbsp;<span
            class="badge badge-pill badge-danger">{{creditRequestsAmount}}</span></ng-template>
        <pos-credit-requests-in-process [customer]="currentCustomer"
          (getAmountOfRequests)="getAmountofCreditRequests($event)"></pos-credit-requests-in-process>
      </tab>
      <tab>
        <ng-template tabHeading><i class="fa fa-file-text"></i> Notas de Crédito &nbsp;<span
            class="badge badge-pill badge-danger">{{creditNotesAmount}}</span></ng-template>
        <app-customer-credit-notes [customer]="currentCustomer"
          (getAmountOfNotes)="getAmountofCreditNotes($event)"></app-customer-credit-notes>
      </tab>
      <tab>
        <ng-template tabHeading><i class="fa fa-regular fa-rectangle-list"></i> Cotizaciones &nbsp;<span
            class="badge badge-pill badge-danger">{{ordersAmount}}</span></ng-template>
        <app-customer-quotations [customer]="currentCustomer"
          (getAmountOfOrders)="getAmountofOrders($event)"></app-customer-quotations>
      </tab>
      <tab>
        <ng-template tabHeading><i class="fa fa-file-text"></i> Contratos Cancelados &nbsp;<span
            class="badge badge-pill badge-danger">{{canceledLoansAmount}}</span></ng-template>
        <app-customer-loans-canceled [customer]="this.currentCustomer"
          [customerStatus]="currentCustomerCreditConditions.estadoCliente"
          (getAmountOfLoans)="getAmountofLoansCanceled($event)"></app-customer-loans-canceled>
      </tab>
      <tab>
        <ng-template tabHeading><i class="fa fa-file-text"></i> Historial de Recaudos &nbsp;<span
            class="badge badge-pill badge-danger">{{amountOfRecollections}}</span></ng-template>
        <app-customer-recollection-list [customerCode]="this.currentCustomer.code"
          (amountOfRecollections)="handleAmountOfRecollectionChange($event)"></app-customer-recollection-list>
      </tab>
    </tabset>
  </div>
</div>